@if (isLoading) {
  <div class="xi-loader-container__center">
    <xi-animation [loop]="true" animation="cx_loader"></xi-animation>
  </div>
}

<ng-container *transloco="let t; read: 'widgets.options'">
  @if (!isLoading) {
    <div
      class="xi-modal__container"
      [ngClass]="
        twoBigNumbers
          ? 'big-number-chart-options-dialog__container--wide'
          : 'big-number-chart-options-dialog__container--normal'
      "
    >
      <h1 class="xi-modal__title kxi-text-center kxi-text-xlarge">{{ t('chart-options') }}</h1>
      <div class="big-number-chart-options-dialog__form-container">
        <app-big-number-chart-options
          [data]="bigNumberDataOne"
          (formChanged)="onFormChanged($event, 'formOne')"
        ></app-big-number-chart-options>
        @if (twoBigNumbers) {
          <app-big-number-chart-options
            [data]="bigNumberDataTwo"
            (formChanged)="onFormChanged($event, 'formTwo')"
          ></app-big-number-chart-options>
        }
      </div>
      <div class="xi-modal__actions big-number-chart-options-dialog__actions">
        <xi-default-button
          [text]="t('cancel')"
          fill="text"
          (onClick)="onCancel()"
        ></xi-default-button>
        <xi-default-button
          [text]="t('apply')"
          (onClick)="onSave()"
          [disabled]="isFormInvalid"
        ></xi-default-button>
      </div>
    </div>
  }
</ng-container>
